/* eslint-disable import/no-unresolved */
import { SecondaryDetails } from "src/helpers/FormDetails/ProposalDetails/interfaces";
import { IAssignmentClauseDetails } from "src/redux/Reducers/AssignmentClauseDetails/interface";
import * as types from "../../Types/assignmentClauseDetails";

export const setAssignmentClause = (payload: Partial<IAssignmentClauseDetails>) => ({
  type: types.SET_ASSIGNMENT_CLAUSE_DETAILS,
  payload
});

export const saveAssignmentClauseDetails = (
  apiData: any,
  masterData: any,
  leadId: string,
  address: SecondaryDetails
) => ({
  type: types.SAVE_ASSIGNMENT_CLAUSE_DETAILS,
  payload: { apiData, masterData, leadId, address }
});
